module.exports = __webpack_public_path__ + "img/ico-active-media.a0767d8c.svg";